import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1161 (people & access).
// Contract: specs/_product/field-primitive-registry.md §1 ('phone').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function PhoneField(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="phone" inputType="tel" />;
}
